import {CameraLayoutType, CameraViewMode} from "../../api/generated/model";

export class CameraLayoutData {
	enabled: boolean = true;
	svgs: Map<CameraViewMode, string>;

	constructor(svgs: [CameraViewMode, string][], enabled: boolean = true) {
		this.svgs = new Map(svgs ?? []);
		this.enabled = enabled;
	}
}

export const CameraLayoutMap = new Map<CameraLayoutType, CameraLayoutData>([
	[CameraLayoutType.Single, new CameraLayoutData([[CameraViewMode.AllScreens, "one_1_1"]])],
	[
		CameraLayoutType.Quad,
		new CameraLayoutData([
			[CameraViewMode.AllScreens, "quad_4_1_1_1_1"],
			[CameraViewMode.Screen1, "quad_4_1_0_0_0"],
			[CameraViewMode.Screen2, "quad_4_0_1_0_0"],
			[CameraViewMode.Screen3, "quad_4_0_0_1_0"],
			[CameraViewMode.Screen4, "quad_4_0_0_0_1"],
		]),
	],
	[
		CameraLayoutType.TwinView,
		new CameraLayoutData([
			[CameraViewMode.AllScreens, "two_2_1_1"],
			[CameraViewMode.Screen1, "two_2_1_0"],
			[CameraViewMode.Screen2, "two_2_0_1"],
		]),
	],
	[
		CameraLayoutType.BSS,
		new CameraLayoutData([
			[CameraViewMode.AllScreens, "three_3_1_1_1"],
			[CameraViewMode.Screen1, "three_3_1_0_0"],
			[CameraViewMode.Screen2, "three_3_0_1_0"],
			[CameraViewMode.Screen3, "three_3_0_0_1"],
		]),
	],
	[
		CameraLayoutType.BSSS,
		new CameraLayoutData([
			[CameraViewMode.AllScreens, "quadTop_4_1_1_1_1"],
			[CameraViewMode.Screen1, "quadTop_4_1_0_0_0"],
			[CameraViewMode.Screen2, "quadTop_4_0_1_0_0"],
			[CameraViewMode.Screen3, "quadTop_4_0_0_1_0"],
			[CameraViewMode.Screen4, "quadTop_4_0_0_0_1"],
		]),
	],
	[
		CameraLayoutType.PictureInPicture,
		new CameraLayoutData([
			[CameraViewMode.AllScreens, "twoPP_2_1_1"],
			[CameraViewMode.Screen1, "twoPP_2_1_0"],
			[CameraViewMode.Screen2, "twoPP_2_0_1"],
		]),
	],
	[
		CameraLayoutType.TwoByThree,
		new CameraLayoutData([
			[CameraViewMode.AllScreens, "six_1_1_1_1_1_1"],
			[CameraViewMode.Screen1, "six_1_0_0_0_0_0"],
			[CameraViewMode.Screen2, "six_0_1_0_0_0_0"],
			[CameraViewMode.Screen3, "six_0_0_1_0_0_0"],
			[CameraViewMode.Screen4, "six_0_0_0_1_0_0"],
			[CameraViewMode.Screen5, "six_0_0_0_0_1_0"],
			[CameraViewMode.Screen6, "six_0_0_0_0_0_1"],
		]),
	],
	[
		CameraLayoutType.ThreeByThree,
		new CameraLayoutData([
			[CameraViewMode.AllScreens, "nine_1_1_1_1_1_1_1_1_1"],
			[CameraViewMode.Screen1, "nine_1_0_0_0_0_0_0_0_0"],
			[CameraViewMode.Screen2, "nine_0_1_0_0_0_0_0_0_0"],
			[CameraViewMode.Screen3, "nine_0_0_1_0_0_0_0_0_0"],
			[CameraViewMode.Screen4, "nine_0_0_0_1_0_0_0_0_0"],
			[CameraViewMode.Screen5, "nine_0_0_0_0_1_0_0_0_0"],
			[CameraViewMode.Screen6, "nine_0_0_0_0_0_1_0_0_0"],
			[CameraViewMode.Screen7, "nine_0_0_0_0_0_0_1_0_0"],
			[CameraViewMode.Screen8, "nine_0_0_0_0_0_0_0_1_0"],
			[CameraViewMode.Screen9, "nine_0_0_0_0_0_0_0_0_1"],
		]),
	],
]);
